import { Button, Modal } from "@alm/flow-ds/components";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
	saveAndCloseBtnClick: () => void;
	closeBtnClick: () => void;
	cancelBtnClick: () => void;
}

function UnsavedChanges({
	saveAndCloseBtnClick,
	closeBtnClick,
	cancelBtnClick,
}: Props) {
	const { t } = useTranslation();

	return (
		<Modal
			isOpen={true}
			showHeaderClose={false}
			close={cancelBtnClick}
			title={t("main.activities.unsavedChanges")}
			closeAriaLabel={t("main.icons.closeModal")}
			modalScrollable={true}
			footer={
				<div className="d-flex justify-content-between w-100">
					<Button
						className="me-auto m-0 p-1"
						label={t("common.labels.cancel")}
						onClick={cancelBtnClick}
					/>
					<div>
						<Button
							className="btn-default"
							label={t("common.labels.close")}
							onClick={closeBtnClick}
						/>
						<Button
							className="btn-primary"
							label={t("common.labels.saveAndClose")}
							onClick={() => {
								saveAndCloseBtnClick();
								cancelBtnClick();
							}}
						/>
					</div>
				</div>
			}>
			<p aria-live="assertive">
				{t("main.activities.unsavedChangesMsg")}
			</p>
		</Modal>
	);
}

export default React.memo(UnsavedChanges);
